import "./LoginPage.scss";
import Logo from "../../../assets/logo.svg";
import { useAuth } from "../../../auth";
import { Button } from "@fsg/gui-bits";
import ReactGA from "react-ga4";
import { useState } from "react";

function LoginPage() {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const onSignIn = () => {
    setLoading(true);
    login();
  };
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Login Page",
  });

  return (
    <div className="login-page">
      <div className="image-wrapper">
        <img src={Logo} alt="FSG" />
      </div>
      <div>
        <Button onClick={onSignIn} disabled={loading}>
          Login
        </Button>
      </div>
    </div>
  );
}

export default LoginPage;
